import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import * as R from "ramda"
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { tagNames } from '../../../../../../redux/tag-names/action';
import { selectTagNamesListItems } from '../../../../../../redux/tag-names/selector';
import { setDisplayText } from '../../../../../../common/services/tag-names.service';
import OpportunityComponent from '../components/opportunity.component';
import { opportunities } from '../../../../../../redux/opportunities/action';
import { selectOpportunitiesQueryItems } from '../../../../../../redux/opportunities/selector';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { relatedToTypes } from '../../../../../../redux/related-to-types/action';
import { selectRelatedToTypesListItems } from '../../../../../../redux/related-to-types/selector';
import { leads } from '../../../../../../redux/leads/action';
import { selectLeadsListItems } from '../../../../../../redux/leads/selector';
import { selectCrmcontactsListItems } from '../../../../../../redux/crm-contacts/selector';
import { crmcontacts } from '../../../../../../redux/crm-contacts/action';

const CrmOpportunity = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const libraryListItems = storePersist.get("library")?.current;
    const queryItems = useSelector(selectOpportunitiesQueryItems)
    const accountsListItems = useSelector(selectAccountsListItems)
    const contactsListItems = useSelector(selectCrmcontactsListItems)
    const leadsListItems = useSelector(selectLeadsListItems)
    const tagNameListItems = useSelector(selectTagNamesListItems)
    const sourceTypeListItems = useSelector(selectRelatedToTypesListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedOpportunity, setSelectedOpportunity] = useState<any>([])
    const [selectedOpportunityTaskActivity, setSelectedOpportunityTaskActivity] = useState<any>([])
    const [selectedOpportunityCallLog, setSelectedOpportunityCallLog] = useState<any>([])

    const fetchLeadById = () => {
        dispatch(opportunities.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/opportunities/query`,
            entity: 'opportunities',
            jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleTaskActivityInnerFormChange: any = (event: any, field: string) => {
        setSelectedOpportunityTaskActivity({ ...selectedOpportunityTaskActivity, [field]: event });
    }

    const handleCallActivityInnerFormChange: any = (event: any, field: string) => {
        setSelectedOpportunityCallLog({ ...selectedOpportunityCallLog, [field]: event });
    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedOpportunity({ ...selectedOpportunity, [fields[0]]: value });
    }

    useEffect(
        () => {
            dispatch(tagNames.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
                entity: 'tagNames',
                jsonData: {}
            })).then(() => {
                dispatch(accounts.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/accounts/list`,
                    entity: 'accounts',
                    jsonData: {}
                }))
            }).then(() => {
                dispatch(relatedToTypes.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/related-to-types/list`,
                    entity: 'relatedToTypes',
                    jsonData: {
                        Records: [
                            {
                                SourceTypeId: 13
                            }
                        ]
                    },
                }))
            }).then(() => {
                dispatch(crmcontacts.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/contacts/list`,
                    entity: 'contacts',
                    jsonData: {}
                }))
            }).then(() => {
                dispatch(leads.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads/list`,
                    entity: 'leads',
                    jsonData: {}
                }))
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchLeadById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        },
        []
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedOpportunity(queryItems?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(opportunities.resetAction({ actionType: 'update' }))
            await dispatch(opportunities.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/opportunities`,
                entity: 'opportunities',
                jsonData: {
                    Records: [
                        selectedOpportunity
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(opportunities.resetAction({ actionType: 'create' }))
            await dispatch(opportunities.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/opportunities`,
                entity: 'opportunities',
                jsonData: {
                    Records: [
                        selectedOpportunity
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/management/sales/crm/opportunities')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <OpportunityComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedOpportunity={selectedOpportunity}
                    selectedOpportunityTaskActivity={selectedOpportunityTaskActivity}
                    selectedOpportunityCallLog={selectedOpportunityCallLog}
                    handleTaskActivityInnerFormChange={handleTaskActivityInnerFormChange}
                    handleCallActivityInnerFormChange={handleCallActivityInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accountNameList={accountsListItems?.result?.items}
                    opportunityType={libraryListItems?.OpportunityType}
                    leadSource={libraryListItems?.SalesSource}
                    opportunityStage={libraryListItems?.OpportunityStage}
                    contactNameLists={contactsListItems?.result?.items}
                    campaigns={libraryListItems?.CampaignType}
                    tagNames={setDisplayText(tagNameListItems?.result?.items)}
                    sourceType={sourceTypeListItems?.result?.items}
                    leads={leadsListItems?.result?.items}
                    taskStatus={libraryListItems?.TaskStatus}
                />
            }
        </>
    )
}

export default CrmOpportunity;